import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { TeamsListPage } from '@/pages/teams/teams-list-page';

/** URL-synced filters.  kind: omitted = shared teams; 'personal' / 'all'. */
const SearchSchema = z.object({
  q: z.string().max(200).optional().catch(undefined),
  kind: z.enum(['personal', 'all']).optional().catch(undefined),
  plan: z.string().max(64).optional().catch(undefined),
  status: z.enum(['free', 'trial', 'active', 'past_due', 'cancelled', 'lifetime']).optional().catch(undefined),
  archived: z.enum(['1']).optional().catch(undefined),
  offset: z.coerce.number().int().min(0).optional().catch(undefined),
});
export type TeamsSearch = z.infer<typeof SearchSchema>;

export const Route = createFileRoute('/teams/')({
  component: TeamsListPage,
  validateSearch: (s) => SearchSchema.parse(s),
});
